import React, { useState, useEffect } from "react";


function weAreOpen(time) {
    var d = new Date(); // current time
    var hours = d.getHours();
    var mins = d.getMinutes();
    var day = d.getDay();
    var startHour = time.startHour;
    var startMinutes = time.startMinutes;
    var closingHour = time.closingHour;
    var closingMinutes = time.closingMinutes;

    return day >= 1 &&
        day <= 5 &&
        (hours > startHour || hours === startHour && mins >= startMinutes) &&
        (hours < closingHour || hours === closingHour && mins <= closingMinutes);
}


export function ContactBar(props) {

    const [afterHours, setAfterHours] = useState(false);

    useEffect(() => {
        setAfterHours(!weAreOpen({
            startHour: props.data.startHour,
            startMinutes: props.data.startMinutes,
            closingHour: props.data.closingHour,
            closingMinutes: props.data.closingMinutes
        }));
    }, []);

    return (
        <div className="contact-bar">
            {afterHours &&
                <div dangerouslySetInnerHTML={{
                    __html: props.data.closedText
                }}></div>
            }
            <div dangerouslySetInnerHTML={{
                __html: props.data.text
            }}></div>
        </div>
    )
}